import { Stack, Typography } from "@mui/material";
// @ts-ignore
import error404Img from "assets/images/error404.webp";
import { ErrorLayout } from "./ErrorLayout";
import { Button } from "components/button";
import { useNavigate } from "react-router-dom";
export const Error404Component = ({
  title,
  subtitle,
  rightSideImg,
  showCta = true,
  ctaLabel,
  onCtaClick,
}: {
  title?: string;
  subtitle?: string;
  rightSideImg?: string;
  showCta?: boolean;
  /** Overrides the default "Back to home" label. */
  ctaLabel?: string;
  /**
   * Overrides the default navigation to /app/home. Needed on unauthenticated
   * screens, where sending the visitor into the app would bounce them to login.
   */
  onCtaClick?: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <ErrorLayout
      errorImg={rightSideImg || error404Img}
      leftSide={
        <Stack
          sx={{
            maxWidth: "360px",
            gap: "16px",
          }}
        >
          <Typography variant="h3">
            {title ? title : "Looks like a blip!"}
          </Typography>
          <Typography
            variant="body-large"
            sx={{
              textAlign: "justify",
            }}
          >
            {subtitle
              ? subtitle
              : "Try refreshing, let’s get things back on track."}
          </Typography>
          {showCta && (
            <Button
              fullWidth
              onClick={() => {
                if (onCtaClick) {
                  onCtaClick();
                  return;
                }
                navigate("/app/home");
              }}
            >
              {ctaLabel ? ctaLabel : "Back to home"}
            </Button>
          )}
        </Stack>
      }
    />
  );
};
